import React from 'react';
import { motion } from 'framer-motion';
import { PhoneIcon, SparklesIcon } from 'lucide-react';
export function PromoBanner() {
  return <section className="bg-brand-gradient relative overflow-hidden py-12 md:py-16 shadow-[0_0_40px_rgba(242,183,5,0.3)] z-20" data-id="element-286">
      {/* Animated background pattern */}
      <motion.div animate={{
      backgroundPosition: ['0px 0px', '24px 24px']
    }} transition={{
      repeat: Infinity,
      duration: 4,
      ease: 'linear'
    }} className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 2px, transparent 0)',
      backgroundSize: '24px 24px'
    }} data-id="element-287"></motion.div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-288">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12" data-id="element-289">
          {/* Left - Offers */}
          <div className="flex flex-col md:flex-row items-center gap-6 text-center md:text-left w-full lg:w-auto" data-id="element-290">
            <motion.div animate={{
            rotate: [0, 10, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 2,
            ease: 'easeInOut'
          }} className="hidden md:flex w-16 h-16 rounded-full bg-white/20 items-center justify-center shrink-0 backdrop-blur-sm border border-white/30 shadow-lg" data-id="element-291">
              <SparklesIcon className="w-8 h-8 text-white" data-id="element-292" />
            </motion.div>

            <div data-id="element-293">
              <div className="flex flex-wrap justify-center md:justify-start gap-3 mb-4" data-id="element-294">
                <motion.span animate={{
                scale: [1, 1.05, 1]
              }} transition={{
                repeat: Infinity,
                duration: 2
              }} className="bg-white text-burgundy px-4 py-1.5 rounded-full font-bold text-sm md:text-base uppercase tracking-wider shadow-lg" data-id="element-295">
                  $10 OFF Braids $80+
                </motion.span>
                <motion.span animate={{
                scale: [1, 1.05, 1]
              }} transition={{
                repeat: Infinity,
                duration: 2,
                delay: 1
              }} className="bg-jet text-golden px-4 py-1.5 rounded-full font-bold text-sm md:text-base uppercase tracking-wider shadow-lg" data-id="element-296">
                  $20 OFF Braids $180+
                </motion.span>
              </div>

              <h3 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-white leading-tight mb-2 text-glow" data-id="element-297">
                Limited Time Special Offers
              </h3>
              <p className="text-white/90 text-lg md:text-xl font-medium" data-id="element-298">
                Walk-ins welcome — mention this promo to claim your discount!
              </p>
            </div>
          </div>

          {/* Right - CTA */}
          <motion.a whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} href="tel:3013858034" className="shrink-0 bg-white text-burgundy hover:bg-cream px-8 py-5 rounded-sm font-bold transition-all shadow-xl text-lg md:text-xl uppercase tracking-wider inline-flex items-center justify-center gap-3 border-2 border-white hover:border-golden w-full md:w-auto" data-id="element-299">
            <motion.div animate={{
            rotate: [0, -15, 15, -15, 15, 0]
          }} transition={{
            repeat: Infinity,
            duration: 1.5,
            repeatDelay: 3
          }} data-id="element-300">
              <PhoneIcon className="w-6 h-6" data-id="element-301" />
            </motion.div>
            Call Now to Claim
          </motion.a>
        </motion.div>
      </div>
    </section>;
}